module.exports = __webpack_public_path__ + "static/assets/43be172b28ef3a87d3718418822090d9.png";